import React, { Component } from 'react';

import { Map as LeafletMap, TileLayer, GeoJSON, Polyline, Marker } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { scaleLinear } from 'd3-scale';

import MapDrawer from './Mapdrawer';
import MapUtils from './map-utils';

const mapConfig = {
  center: [51.5, 11],
  minZoom: 5,
  maxZoom: 10,
  attribution: 'Karte: <a href="http://openstreetmap.org">OpenStreetMap-Mitwirkende</a>, <a href="http://mapbox.com">Mapbox</a>',
};

class Map extends Component {
  state = {
    viewport: {
      center: mapConfig.center,
      zoom: mapConfig.zoom,
    },
    map: null
  }

  constructor(props) {
    super(props);
    this.mapConfig = Object.assign({}, mapConfig, props.config);
    this.tileLayerUrl = 'https://maps.tilehosting.com/c/a0a037d7-f288-42a8-88cf-666cf06cee7a/styles/positron-65071-9290b-ff1e2/{z}/{x}/{y}@2x.png?key=68ErAz6zqgdV9jEjhpuz';

    this.markerIcon = L.divIcon({
      className: 'pen-icon',
      html: `<img src="images/map-cta-pen.gif" />`,
      iconSize: [60, 93],
      iconAnchor: [0, 0]
    });

    this.markerUpdated = false;
    this.markerScale = scaleLinear()
      .domain([9, 10, 10.5])
      .range([41, 80, 115]);
  }

  componentDidMount() {
    this.goToResult();
    this.props.onMapMounted(this.mapComp.leafletElement);

    window.map = this.mapComp.leafletElement;

    this.setState({ map: this.mapComp.leafletElement });
  }

  componentDidUpdate(nextProps) {
    if (!this.markerUpdated && this.penMarker) {
      const zoom = this.mapComp.leafletElement.getZoom();

      this.penMarker.leafletElement._icon.style.opacity = 1;
      this.penMarker.leafletElement._icon.style.width = `${this.markerScale(zoom)}px`;
      this.penMarker.leafletElement._icon.style.left = `0`;
      this.penMarker.leafletElement._icon.style.top = `0`;

      this.markerUpdated = true;
    }
  }

  drawServerCoords() {
    if (!this.props.serverCoords.length) {
      return null;
    }
    return this.props.serverCoords.map((coords, i) => (
      <Polyline
        key={`servercoord_${i}`}
        positions={coords}
        color="#e74c3c"
        opacity={0.2}
        weight={1}
      />
    ));
  }

  goToResult() {
    MapUtils.disable(this.mapComp.leafletElement);
    this.mapComp.leafletElement.setMinZoom(mapConfig.minZoom);

    this.mapComp.leafletElement.fitBounds(
      [[47.2, 4.5], [55, 15]],
      { paddingTopLeft: [0, 0], paddingBottomRight: [0, 0] }
    );
  }

  onViewportChanged = viewport => {
    //this.setState({ viewport })
  }

  zoom = (amount) => {
    this.mapComp.leafletElement.setZoom(this.mapComp.leafletElement.getZoom() + amount);
  }

  getMarkerLabels = () => {
    return MapUtils.getLabels().map((m, i) => {
      const icon = L.divIcon({
        className: `map__resultlabel ${m.position || 'left'} label-${i}`,
        html: m.name,
        iconSize: [150, 20],
        iconAnchor: [0, 0]
      });
      return <Marker key={`marker_${i}`} position={m.latlng} icon={icon} />;
    });
  }

  render() {
    return (
      <LeafletMap
        onViewportChanged={this.onViewportChanged}
        viewport={this.state.viewport}
        center={this.mapConfig.center}
        id="map-comp"
        zoomControl={false}
        minZoom={this.mapConfig.minZoom}
        maxZoom={this.mapConfig.maxZoom}
        zoomSnap={.25}
        zoomDelta={.25}
        ref={ref => {this.mapComp = ref;}}
        tap={false}
      >
        <TileLayer url={this.tileLayerUrl} />
        <GeoJSON
          key="berlin"
          data={this.props.berlinGeojson}
          fill={false}
          weight={1}
          color="#5a5a5a"
        />
        {this.props.step === 'draw' && (
          <Marker
            ref={ref => { this.penMarker = ref; }}
            position={[54, 10.5]}
            icon={this.markerIcon}
          />
        )}
        {this.drawServerCoords()}
        {this.props.step === 'result' && [
          <GeoJSON
            key="innerborder"
            data={this.props.innerBorder}
            fill={false}
            weight={3}
            color="#5a5a5a"
          />,
          <GeoJSON
            key="westborder"
            data={this.props.westGeojson}
            fill={false}
            weight={2}
            color="#5a5a5a"
          />,
          ...this.getMarkerLabels()
        ]}
        {this.props.drawCoords &&
          <Polyline
            positions={this.props.drawCoords}
            color="#e74c3c"
          />
        }
        {this.props.step === 'draw' && this.state.map ? <MapDrawer
          berlin={this.props.berlinGeojson}
          westGeojson={this.props.westGeojson}
          eastGeojson={this.props.eastGeojson}
          innerBorder={this.props.innerBorder}
          onDrawingFinished={this.props.onDrawingFinished}
          onDrawError={this.props.onDrawError}
          step={this.props.step}
          onLoad={this.props.onLoad}
          map={this.state.map}
        /> : null}
      </LeafletMap>
    );
  }
}

export default Map;
